export default "__VITE_ASSET__BT97_EfS__"